'use strict';
import angular from 'angular';
var CredentialController = /** @class */ (function () {
    /*@ngInject*/
    function CredentialController(Auth, $state, $cookies, $scope, $timeout, Util, CredentialService, SignupService) {
        //$scope.$watch(() => this.credentialType, function(newVal, oldVal) {
        //  console.log('Credential Type changed to ' + newVal + ' from ' + oldVal);
        //});
        //
        this.credentialType = null;
        this.selectedCredential = null;
        this.files = null;
        this.file = null;
        this.log = null;
        this.progressPercentage = 0;
        this.showAlert = false;
        this.closeAlertMessage = function () {
            this.showAlert = false;
        };
        this.$cookies = $cookies;
        this.$timeout = $timeout;
        this.credentialService = CredentialService;
        this.Util = Util;
        this.SignupService = SignupService;
        var self = this;
        self.credentials = [{
                id: 1,
                credentialType: null,
                file: null,
                status: null,
                newCred: true
            }];
        self.credentialService.getDoctorTypes().then(function (response) {
            self.credentialTypes = response.data.response.currentPage;
        });
        $scope.$watch('cd.files', function () {
            //self.upload(self.files);
        });
        $scope.$watch('cd.file', function () {
            if (self.file != null) {
                self.showAlert = false;
                if (self.file.size) {
                    if (self.selectedCredential != null) {
                        self.files = [self.file];
                        self.showFileSelector = false;
                        self.selectedCredential.status = 'Upload Pending';
                        self.selectedCredential.file = self.file;
                        self.SignupService.fireEvent('uploadCredential');
                    }
                    else {
                        alert('Select Credential Type before adding the File');
                    }
                }
                else {
                    self.Util.setPageErrors('Cannot upload empty file', '', self);
                    self.SignupService.fireEvent('uploadCredentialError');
                    self.showAlert = true;
                    self.showFileSelector = true;
                }
            }
        });
        self.log = '';
        // Listening to the event from submit button in parent (container) template
        $scope.$on('submitForm', function (event, data) {
            self.onUpdate({
                $event: {
                    credentials: self.credentials
                }
            });
        });
    }
    CredentialController.prototype.changeCredType = function (credential) {
        var self = this;
        self.selectedCredential = credential;
        self.SignupService.fireEvent('selectCredential');
    };
    CredentialController.prototype.addCredential = function () {
        // Mark previously added credentials as not new.
        // There can be only one new or 'current' credential
        for (var i in this.credentials) {
            this.credentials[i].newCred = false;
        }
        this.file = null;
        this.credentials.push({
            id: this.credentials.length + 1,
            credentialType: null,
            fileName: null,
            status: null,
            newCred: true
        });
    };
    CredentialController.prototype.deleteCredential = function (credential) {
        this.credentials = this.credentials.filter(function (x) {
            return x.id != credential.id;
        });
    };
    // This is to ensure that any changes to our local user object don't reflect in
    // the parent object that was passed to us.
    CredentialController.prototype.$onChanges = function (changes) {
        if (changes.credentials) {
            this.credentials = angular.copy(this.credentials);
        }
    };
    return CredentialController;
}());
export default CredentialController;
//# sourceMappingURL=credential.controller.js.map